import React, { useState, useCallback, useEffect, useRef } from "react";
import SearchBar from "./SearchBar";
import {
  getGridValidateCheck,
  saveGridCheckData,
  isFieldDisabled,
} from "../../../utils/validators";
import ButtonBar from "../../../components/Layout/ButtonBar";
import { useAxiosWithAuthorization } from "../../../utils/api";
import { ModalConfirm } from "../../../components/Confirm";
import AUIGrid from "../../../lib/AuiGrid/AUIGridReact";
import { defaultGridProps } from "../../../components/AuiGrid/gridLayout";
import { columnLayout } from "./conlumnLayout";
import { INITIAL_FIELD_RULES } from "./validateFields";
import { useId } from "react-id-generator";
import osq from "../../../images/osq.png";
import SelectBox from "../../../components/SelectBox";
import useAppContext from "../../../utils/Reducers";

const CameraMng = (props) => {
  const myGrid = useRef();
  const [state, setState] = useState("normaled");

  const {
    store: { userInfo, menuKey },
  } = useAppContext();

  useEffect(() => {
    const auiGrid = myGrid.current;
    auiGrid.resize("100%", 370);
  }, [menuKey]);

  //추가, 수정일때 항목의 disabled 결정
  const disabledFields = {
    created: [],
    updated: ["groupId"],
  };

  const initItem = {
    cameraGuid: "",
    cameraNm: "",
    scrapAreaCd: "",
    scrapAreaNm: "",
    cameraIp: "",
    rtspAddr: "",
    cameraPort: "",
    snapshotPrd: "",
    milestoneNm: "",
    sortSeq: "",
    bitrate: "",
    frame: "",
    resolution: "",
    recYn: "Y",
    useYn: "Y",
    status: "C",
  };
  const [fieldValues, setFieldValues] = useState(initItem);

  //카메라정보 검색 URL
  const SERARCH_CAMERA_URL = "/common/camera/searchCameraInfoList.do";
  //카메라정보 저장 URL
  const SAVE_CAMERA_URL = "/common/camera/saveCameraList.do";
  //카메라정보 삭제 URL
  const DELETE_CAMERA_URL = "/common/camera/deleteCameraList.do";

  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: SERARCH_CAMERA_URL,
    },
    { manual: true }
  );

  const [searchParameters, setSearchParameters] = useState({
    schCameraNm: "",
    schScrapAreaCd: "",
  });

  //코드 및 그리드 초기화 및 생성
  useEffect(() => {
    const auiGrid = myGrid.current;
    auiGrid.create(columnLayout, { ...defaultGridProps });
    auiGrid.bind("cellClick", function (event) {
      gridCellClick(event.item);
    });

    //
  }, []);

  const gridCellClick = (item) => {
    // 추가 : editable, 수정 : edtiable, 삭제 : readonly
    //read
    //setFieldsEnabled(auiGrid, item, disabledFields);
    const auiGrid = myGrid.current;
    if (auiGrid.isAddedById(item._$uid)) {
      setState("created");
    } else if (auiGrid.isEditedById(item._$uid)) {
      setState("updated");
    } else if (auiGrid.isRemovedById(item._$uid)) {
      setState("deleted");
      //console.log("삭제 하는 항목");
    } else {
      setState("updated");
    }

    setFieldValues(item);
  };
  const handleMasterSearch = async () => {
    const auiGrid = myGrid.current;
    auiGrid.showAjaxLoader();
    const {
      data: { data },
    } = await fetchData({
      url: SERARCH_CAMERA_URL,
      params: searchParameters,
    });
    auiGrid.setGridData(data);
    setFieldValues(initItem);
    auiGrid.removeAjaxLoader();
  };

  const handleMasterNew = () => {
    const auiGrid = myGrid.current;
    //console.log(initItem);
    auiGrid.addRow(initItem, "last");
    setFieldValues(initItem);
    const items = auiGrid.getSelectedItems()[0];

    gridCellClick(items.item);
  };

  const handleMasterDelete = () => {
    const auiGrid = myGrid.current;
    auiGrid.removeRow("selectedIndex");
  };
  const handleMasterSave = async () => {
    const auiGrid = myGrid.current;
    if (
      await ModalConfirm({
        title: "저장",
        description: "데이터를 저장하시겠습니까?",
      })
    ) {
      let validator = [];

      var items = auiGrid.getGridData();

      const result = getGridValidateCheck(auiGrid, items, INITIAL_FIELD_RULES);
      if (result.isValidate) {
        document.getElementsByName(result.column)[0].focus();
        ModalConfirm({
          title: "필수항목체크",
          description: result.message,
          type: "alert",
        });
        auiGrid.setSelectionByIndex(result.rowIndex);
        gridCellClick(result.rowItem);
        return;
      }
      const addItems = auiGrid.getAddedRowItems();
      const editItems = auiGrid.getEditedRowItems();
      const removeItems = auiGrid.getRemovedItems();
      let param = saveGridCheckData(addItems, editItems, removeItems);
      if (param.length > 0) {
        const {
          data: { data },
        } = await fetchData({
          url: SAVE_CAMERA_URL,
          data: param,
          method: "POST",
        });

        handleMasterSearch();
      } else {
        ModalConfirm({
          title: "필수항목체크",
          description: "저장할 항목이 없습니다. ",
          type: "alert",
        });
      }
    }
  };

  const handleChangeField = useCallback((event) => {
    const auiGrid = myGrid.current;
    //console.log(event);
    const { name, value } = event.target;
    const items = auiGrid.getSelectedItems()[0];
    const item = items.item;
    //console.log("name === " + name + " || value === " + value);

    if (name === "scrapAreaCd") {
      var scrapAreaNm = event.target.options[event.target.selectedIndex].text;
      setFieldValues({
        ...fieldValues,
        [name]: value,
        ["scrapAreaNm"]: scrapAreaNm,
      });
      item[name] = value;
      item["scrapAreaNm"] = scrapAreaNm;
    } else {
      item[name] = value;
      setFieldValues({
        ...fieldValues,
        [name]: value,
      });
    }

    auiGrid.updateRow(item, "selectedIndex");
  });

  const handleMasterExcel = useCallback(() => {
    const auiGrid = myGrid.current;
    auiGrid.exportToXlsx({
      fileName: props.menuInfo.menuNmKor + " 리스트",
      exceptColumnFields: auiGrid.getHiddenColumnDataFields(),
    });
  });
  return (
    <>
      <ButtonBar
        menuInfo={props.menuInfo}
        handleMasterSearch={handleMasterSearch}
        handleMasterNew={handleMasterNew}
        handleMasterDelete={handleMasterDelete}
        handleMasterSave={handleMasterSave}
        handleMasterExcel={handleMasterExcel}
      />
      <SearchBar
        setSearchParameters={setSearchParameters}
        searchParameters={searchParameters}
      />

      <div className="flexible_contents_box">
        <div className="databox">
          <AUIGrid
            ref={myGrid}
            columnLayout={columnLayout}
            gridProps={{ ...defaultGridProps, width: "100%", height: 370 }}
          />
        </div>
        <div className="databox">
          <div className="subdatabox">
            <h5>
              <img src={osq} /> &nbsp;그룹상세정보 &nbsp;
              <br />
            </h5>
            <ul className="t_form">
              <li className="doublehalf">
                <div className="title">
                  <span className="red">*</span>카메라GUID
                </div>
                <div className="formbox">
                  <input
                    id="cameraGuid"
                    name="cameraGuid"
                    disabled={isFieldDisabled(
                      state,
                      "cameraGuid",
                      disabledFields
                    )}
                    value={fieldValues.cameraGuid}
                    onChange={handleChangeField}
                    className="ip2"
                  />
                </div>
              </li>
              <li className="doublehalf">
                <div className="title">
                  <span className="red">*</span>카메라명
                </div>
                <div className="formbox">
                  <input
                    type="text"
                    id="cameraNm"
                    name="cameraNm"
                    style={{ width: "108px;" }}
                    disabled={isFieldDisabled(
                      state,
                      "cameraNm",
                      disabledFields
                    )}
                    onChange={handleChangeField}
                    value={fieldValues.cameraNm}
                    className="ip2"
                  />
                </div>
              </li>
              <li className="doublehalf">
                <div className="title">
                  <span className="red">*</span>하차구역
                </div>
                <div className="formbox">
                  <SelectBox
                    mastCd="SCRAP_AREA_CD"
                    id="scrapAreaCd"
                    name="scrapAreaCd"
                    topSelected="전체"
                    disabled={isFieldDisabled(
                      state,
                      "scrapAreaCd",
                      disabledFields
                    )}
                    onChange={handleChangeField}
                    value={fieldValues.scrapAreaCd}
                    className="ip2"
                  />
                </div>
              </li>
              <li className="doublehalf">
                <div className="title">카메라IP</div>
                <div className="formbox">
                  <input
                    type="text"
                    id="cameraIp"
                    name="cameraIp"
                    style={{ width: "108px;" }}
                    disabled={isFieldDisabled(
                      state,
                      "cameraIp",
                      disabledFields
                    )}
                    onChange={handleChangeField}
                    value={fieldValues.cameraIp}
                    className="ip2"
                  />
                </div>
              </li>
              <li className="half">
                <div className="title">
                  <span className="red">*</span>RTSP주소
                </div>
                <div className="formbox">
                  <input
                    type="text"
                    id="rtspAddr"
                    name="rtspAddr"
                    style={{ width: "108px;" }}
                    disabled={isFieldDisabled(
                      state,
                      "rtspAddr",
                      disabledFields
                    )}
                    onChange={handleChangeField}
                    value={fieldValues.rtspAddr}
                    className="ip2"
                  />
                </div>
              </li>
              <li className="doublehalf">
                <div className="title">카메라포트</div>
                <div className="formbox">
                  <input
                    type="text"
                    id="cameraPort"
                    name="cameraPort"
                    style={{ width: "108px;" }}
                    disabled={isFieldDisabled(
                      state,
                      "cameraPort",
                      disabledFields
                    )}
                    onChange={handleChangeField}
                    value={fieldValues.cameraPort}
                    className="ip2"
                  />
                </div>
              </li>
              <li className="doublehalf">
                <div className="title">스냅샷주기</div>
                <div className="formbox">
                  <input
                    type="text"
                    id="snapshotPrd"
                    name="snapshotPrd"
                    style={{ width: "108px;" }}
                    disabled={isFieldDisabled(
                      state,
                      "snapshotPrd",
                      disabledFields
                    )}
                    onChange={handleChangeField}
                    value={fieldValues.snapshotPrd}
                    className="ip2"
                  />
                </div>
              </li>
              <li className="doublehalf">
                <div className="title">마일스톤명</div>
                <div className="formbox">
                  <input
                    type="text"
                    id="milestoneNm"
                    name="milestoneNm"
                    style={{ width: "108px;" }}
                    disabled={isFieldDisabled(
                      state,
                      "milestoneNm",
                      disabledFields
                    )}
                    onChange={handleChangeField}
                    value={fieldValues.milestoneNm}
                    className="ip2"
                  />
                </div>
              </li>
              <li className="doublehalf">
                <div className="title">중계서버IP</div>
                <div className="formbox">
                  <input
                    type="text"
                    id="serverIp"
                    name="serverIp"
                    style={{ width: "108px;" }}
                    disabled={isFieldDisabled(
                      state,
                      "serverIp",
                      disabledFields
                    )}
                    onChange={handleChangeField}
                    value={fieldValues.serverIp}
                    className="ip2"
                  />
                </div>
              </li>
              <li className="doublehalf">
                <div className="title">
                  <span className="red">*</span>정렬순서
                </div>
                <div className="formbox">
                  <input
                    type="number"
                    min={1}
                    max={100}
                    name="sortSeq"
                    id="sortSeq"
                    disabled={isFieldDisabled(state, "sortSeq", disabledFields)}
                    onChange={handleChangeField}
                    value={fieldValues.sortSeq}
                    className="ip1"
                  />
                </div>
              </li>

              <li className="doublehalf">
                <div className="title">
                  <span className="red">*</span>녹화여부
                </div>
                <div className="formbox">
                  <SelectBox
                    mastCd="USE_YN"
                    id="recYn"
                    name="recYn"
                    topSelected="전체"
                    disabled={isFieldDisabled(state, "recYn", disabledFields)}
                    onChange={handleChangeField}
                    value={fieldValues.recYn}
                    className="ip2"
                  />
                </div>
              </li>
              <li className="doublehalf">
                <div className="title">
                  <span className="red">*</span>사용여부
                </div>
                <div className="formbox">
                  <SelectBox
                    mastCd="USE_YN"
                    id="useYn"
                    name="useYn"
                    topSelected="전체"
                    disabled={isFieldDisabled(state, "useYn", disabledFields)}
                    onChange={handleChangeField}
                    value={fieldValues.useYn}
                    className="ip2"
                  />
                </div>
              </li>
              <li className="doublehalf">
                <div className="title">
                  <span className="red">*</span>전송속도
                </div>
                <div className="formbox">
                  <input
                    type="text"
                    id="bitrate"
                    name="bitrate"
                    style={{ width: "108px;" }}
                    disabled={isFieldDisabled(state, "bitrate", disabledFields)}
                    onChange={handleChangeField}
                    value={fieldValues.bitrate}
                    className="ip2"
                  />
                </div>
              </li>
              <li className="doublehalf">
                <div className="title">
                  <span className="red">*</span>영상프레임수
                </div>
                <div className="formbox">
                  <input
                    type="text"
                    id="frame"
                    name="frame"
                    style={{ width: "108px;" }}
                    disabled={isFieldDisabled(state, "frame", disabledFields)}
                    onChange={handleChangeField}
                    value={fieldValues.frame}
                    className="ip2"
                  />
                </div>
              </li>
              <li className="doublehalf">
                <div className="title">
                  <span className="red">*</span>영상해상도
                </div>
                <div className="formbox">
                  <input
                    type="text"
                    id="resolution"
                    name="resolution"
                    style={{ width: "108px;" }}
                    disabled={isFieldDisabled(
                      state,
                      "resolution",
                      disabledFields
                    )}
                    onChange={handleChangeField}
                    value={fieldValues.resolution}
                    className="ip2"
                  />
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default CameraMng;
